import React, {useEffect, useRef, useState} from "react";
import { createPortal } from "react-dom";
import { LanguageLoader } from '../../assets/languages';
import { useSelector } from "react-redux";

let openModalCount = 0;

const Modal = ({handler, children, onSubmit, onClose, fallDown, trigger, size, title, showButtons=true, fitContent=false, bodyClassName='', autoFocus=true}) =>
{
	const preferences = useSelector((state) => state.preferences);	
	const language = LanguageLoader(preferences.language);
	const [showModal, SetShowModal] = useState(false);
	const [layer, SetLayer] = useState(0);
	const contentRef = useRef(null);
	const showModalRef = useRef(false);

	const OpenModal = () =>
	{
		if(showModalRef.current)
		{
			return;
		}
		openModalCount += 1;
		showModalRef.current = true;
		SetLayer(openModalCount);
		SetShowModal(true);
	};

	const CloseModal = () =>
	{
		if(!showModalRef.current)
		{
			return;
		}
		showModalRef.current = false;
		SetShowModal(false);
		openModalCount = Math.max(0, openModalCount - 1);
	};

	useEffect(() =>
	{
		if(fallDown)
		{
			CloseModal();
			if(onClose)
			{
				onClose();
			}
		}
	// eslint-disable-next-line
	}, [fallDown]);

	useEffect(() =>
	{
		if(trigger)
		{
			OpenModal();
		}
	// eslint-disable-next-line
	}, [trigger]);

	useEffect(() =>
	{
		if(!showModal || !autoFocus)
		{
			return;
		}

		const focusTimer = window.setTimeout(() =>
		{
			const container = contentRef.current;
			if(!container)
			{
				return;
			}
			const focusable = container.querySelector('input:not([disabled]):not([type="hidden"]):not(.date-picker), textarea:not([disabled]), select:not([disabled]), button:not([disabled])');
			focusable?.focus();
		}, 0);

		return () => window.clearTimeout(focusTimer);
	}, [showModal, autoFocus]);

	const HandleSubmit = (keepOpen=false) =>
	{
		if(onSubmit)
		{
			if(onSubmit())
			{
				if(!keepOpen)
				{
					CloseModal();
				}
			}
		}
		else if(!keepOpen)
		{
			CloseModal();
		}
	};
	
	const HandleDecline = () =>
	{
		if(onClose)
		{
			onClose();
		}
		CloseModal();
	};

	const backdropZIndex = 40 + (layer - 1) * 20;
	const contentZIndex = backdropZIndex + 10;
	const wrapperClass = fitContent
		? 'flex justify-center items-center fixed mx-auto top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 max-w-[95vw]'
		: 'flex justify-center items-center fixed w-full md:min-w-[35rem] md:w-2/3 mx-auto top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2';
	const panelClass = fitContent
		? 'modal flex flex-col rounded-lg shadow-lg relative w-full max-h-[90vh]'
		: 'modal flex flex-col rounded-lg shadow-lg relative w-full h-full';
	const bodyClass = bodyClassName || (fitContent ? 'overflow-visible' : 'h-full overflow-auto');

	return (
		<>
			<span className={'cursor-pointer' + (showModal ? ' pointer-events-none' : '')} onClick={OpenModal}>{handler ? handler : <i className='fa fa-link py-3 px-2 bg-primary text-white rounded-md'></i>}</span>
			{showModal ?
			createPortal(
				<>
					<div className={wrapperClass} style={{...size, zIndex: contentZIndex}}>
						<div className={'relative w-full' + (fitContent ? '' : ' h-full')} ref={contentRef}>
							<div className={panelClass}>
								<div className="flex items-center justify-between p-3 border-b border-secondaryBorder shrink-0">
									<span className="text-sm">{title ? title : null}</span>
									<i className="fa fa-times cursor-pointer px-2 hover:text-danger" onClick={HandleDecline}></i>
								</div>
								<div className={'relative p-4 flex-auto text-sm ' + bodyClass}>{children}</div>
								{showButtons && (onSubmit || onClose) ? 
								<div className="flex justify-end p-3 shrink-0 border-t border-secondaryBorder">
									{onSubmit ? <button className="btn-primary" onClick={() => HandleSubmit(false)}>{language["COMPONENTS"]["SAVE"]}</button> : null}
									{onClose ? <button className="btn secondary" onClick={HandleDecline}>{language["COMPONENTS"]["DECLINE"]}</button> : null}
								</div>
								: null }
							</div>
						</div>
					</div>
					<div className="opacity-50 fixed inset-0 bg-black" style={{zIndex: backdropZIndex}} onClick={HandleDecline}></div>
				</>,
				document.body
			) : null}
		</>
	);
}

export default Modal;
